export default {
  title: 'Carrinho',
  buttons: {
    login_to_checkout: 'Iniciar sessão para finalizar',
    checkout: 'Checkout',
  },
  go_to_menu: 'Ir para o menu',
  toasts: {
    cashback_points_removed: 'O teu saldo de pontos mudou, por isso removemos os pontos desta encomenda.',
  },
};
